import { Action } from "../actions/types"
import { TripMasterType, TripMasterActionList } from "../actions/tripMasterActions"

const initialValue: Array<TripMasterType> = []

const tripMasterReducer = (state: Array<TripMasterType> = initialValue, action: Action) => {
    switch (action.type) {

        case TripMasterActionList.ADD_TRIP_MASTER:
            return [
                ...state,
                action.data,
            ]

        case TripMasterActionList.UPDATE_TRIP_MASTER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case TripMasterActionList.FETCH_TRIP_MASTER:
            return action.data

        case TripMasterActionList.DELETE_TRIP_MASTER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default tripMasterReducer